import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "../CartPage/CartPage.css";
const contributors = [
  {
    firstName: "Efehan",
    lastName: "Akcel",
    studentId: "42073",
    mobile: "Not given",
    link: "/",
    imgUrl: "https://img.freepik.com/free-icon/user_318-159711.jpg",
  },
  {
    firstName: "Ufuk",
    lastName: "Emre İşbilir",
    studentId: "42393",
    mobile: "Not given",
    link: "/",
    imgUrl: "https://img.freepik.com/free-icon/user_318-159711.jpg",
  },
  {
    firstName: "Samad",
    lastName: "Samadov",
    studentId: "41296",
    mobile: "Not given",
    link: "/",
    imgUrl: "https://img.freepik.com/free-icon/user_318-159711.jpg",
  },
];

export default function Contributors() {
  return (
    <div>
      <Helmet>
        <title>Contributors</title>
      </Helmet>
      <main className="h-screen max-w-8xl flex flex-col mx-auto px-4 sm:px-6 lg:px-8 py-12 justify-between">
        <h1 className="mb-8 text-3xl font-bold flex justify-center">
          Contributors
        </h1>

        <div className="flex w-full justify-center ">
          <div className="grid grid-cols-1  gap-4">
            <div className="md:col-span-8">
              <div className="bg-white border-b border-gray-200 shadow sm:rounded-lg hover:transform hover:scale-105 backface-hidden duration-500">
                <div className="overflow-x-auto max-w-full">
                  <table className="min-w-full divide-y divide-gray-200 ">
                    <thead className="bg-gray-50">
                      <tr className=" md:table-row">
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                        >
                          Coontributor
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                        >
                          Firstname
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                        >
                          Lastname
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                        >
                          Student ID
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                        >
                          Mobile
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                        >
                          Link
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {contributors.map((contributor) => (
                        <tr key={contributor._id}>
                          <td className="whitespace-nowrap px-6 py-4 md:px-2 md:py-3">
                            <div className="flex items-center">
                              <div className="h-10 w-10 flex-shrink-0">
                                <img
                                  className="h-10 w-10 rounded-full"
                                  src={contributor.imgUrl}
                                  alt={contributor.firstName}
                                />
                              </div>
                              <div className="ml-4">
                                <div className="text-sm font-medium text-gray-900 whitespace-normal">
                                  <Link to={`/products/${contributor.id}`}>
                                    {contributor.title}
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                            {contributor.firstName}
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                            {contributor.lastName}
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                            {contributor.studentId}
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                            {contributor.mobile}
                          </td>
                          <Link to={contributor.link}>
                            <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                              Link
                            </td>
                          </Link>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p className=" container mx-auto text-center mb-8 text-xl font-bold items-center">
          The intention behind creating this app by
          <Link to="https://vizja.pl">
            <span className="text-orange-500">&nbsp;AEH&nbsp;</span>
          </Link>
          students was purely for study purposes. It is not intended for
          production use and should be treated as such.
        </p>
      </main>
    </div>
  );
}
